import React, { useState, useEffect } from 'react';
import { RefreshCw, X } from 'lucide-react';
import axios from 'axios';

const CHECK_INTERVAL = 5 * 60 * 1000; // Check every 5 minutes
const STORAGE_KEY = 'app_version';

const UpdateBanner = ({ apiUrl }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await axios.get(`${apiUrl}/version`, { withCredentials: true });
        const serverVersion = res.data?.version;
        if (!serverVersion) return;

        const savedVersion = localStorage.getItem(STORAGE_KEY);

        if (!savedVersion) {
          // First visit: save current version
          localStorage.setItem(STORAGE_KEY, serverVersion);
        } else if (savedVersion !== serverVersion) {
          // Version changed: show update banner
          setShowBanner(true);
        }
      } catch {
        // Silently fail
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [apiUrl]);

  const handleUpdate = () => {
    localStorage.setItem(STORAGE_KEY, ''); // Reset so next load saves the new version
    window.location.reload(true);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[200] bg-gradient-to-r from-[#0D47A1] to-[#00B050] text-white px-4 py-2.5 shadow-lg" data-testid="update-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm font-medium">
          <RefreshCw className="h-4 w-4" />
          <span>Une nouvelle version est disponible</span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={handleUpdate}
            className="bg-white text-[#0D47A1] px-4 py-1 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors"
            data-testid="update-btn"
          >
            Mettre à jour
          </button>
          <button
            onClick={() => setShowBanner(false)}
            className="text-white/70 hover:text-white p-1"
            data-testid="dismiss-update-btn"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateBanner;
